var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 87,
    viewBox: "0 0 50 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 87H47.5014V56.3452C46.1634 54.22 43.9583 55.4637 42.115 54.3566C36.6467 51.0766 32.5301 44.6395 25.6554 44.332C16.1319 43.9083 10.8889 53.4478 2.49862 56.3452V87H0V55.0946C0 49.3477 5.46833 40.0064 6.91563 33.2413C8.74523 24.7063 8.20589 16.5472 10.015 8.18303L11.8651 11.9209C15.0328 8.29237 18.8558 5.25832 23.7439 4.40414C25.71 -1.70496 13.9337 6.07833 17.4768 1.27442C26.2221 -2.23114 37.2201 1.65026 40.2854 11.0121C42.3607 17.3603 41.207 27.0707 42.8386 34.7241C44.0128 40.2319 49.9932 51.3158 49.9932 55.0878V86.9932L50 87Z",
    fill: "#D56B4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLed);
export default __webpack_public_path__ + "static/media/led.127493f4c7d55b0b2d7085fc78ee3b65.svg";
export { ForwardRef as ReactComponent };